import {
  Accordion, AccordionDetails, AccordionSummary, Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import { helpColors, helpEase } from '../style/helpStyles';

const FaqItem = ({
  question, answer, expanded, onChange, isLast,
}) => (
  <Accordion
    expanded={expanded}
    onChange={onChange}
    disableGutters
    elevation={0}
    square
    sx={{
      backgroundColor: 'transparent',
      borderBottom: isLast ? 'none' : `1px solid ${helpColors.line}`,
      '&::before': { display: 'none' },
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon sx={{ color: helpColors.pink, fontSize: 20 }} />}
      sx={{
        padding: 0,
        minHeight: 'unset',
        '& .MuiAccordionSummary-content': { margin: '14px 0' },
        '& .MuiAccordionSummary-expandIconWrapper': { transition: `transform .35s ${helpEase}` },
      }}
    >
      <Typography
        component="h4"
        sx={{
          fontWeight: 600,
          fontSize: 14.5,
          lineHeight: 1.35,
          letterSpacing: '-0.01em',
          textAlign: 'left',
          color: expanded ? helpColors.pink : helpColors.ink,
        }}
      >
        {question}
      </Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ padding: '0 0 16px' }}>
      {answer}
    </AccordionDetails>
  </Accordion>
);

FaqItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isLast: PropTypes.bool,
};

FaqItem.defaultProps = {
  expanded: false,
  isLast: false,
};

export default FaqItem;
